import { appActions } from '../helpers/constants';

const initialState = {
  isUserAuthenticated: false,
  loggedInUser: null,

  applicationLinks: null,

  loading: false
}

const reducer = (state = initialState, action) => {

  const { payload, type } = action;
  
  switch (type) {
    case appActions.GET_APPLICATION_LINKS:
      return {
        ...state,
        applicationLinks: payload
      }
    case appActions.APP_LOADING:
      return {
        ...state,
        loading: payload
      }
    case appActions.USER_AUTH_SUCCESS:
    case appActions.USER_REAUTH_SUCCESS:
    case appActions.NEW_USER_SUCCESS:
      return {
        ...state,
        isUserAuthenticated: true,
        loggedInUser: payload
      }
    case appActions.USER_AUTH_FAIL:
    case appActions.USER_REAUTH_FAIL:
    case appActions.NEW_USER_FAIL: // Cause cause current user to be logged out if they create a new account and it fails?
      return {
        ...state,
        isUserAuthenticated: false
      }
    case appActions.USER_LOG_OUT:
      return {
        ...state,
        isUserAuthenticated: false,
        loggedInUser: null
      }
    default:
      return {
        ...state
      }
  }
  
}

export { reducer as appReducer };